(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __moduleCache = /* @__PURE__ */ new WeakMap();
  var __toCommonJS = (from) => {
    var entry = __moduleCache.get(from),
      desc;
    if (entry) return entry;
    entry = __defProp({}, "__esModule", { value: true });
    if ((from && typeof from === "object") || typeof from === "function")
      __getOwnPropNames(from).map(
        (key) =>
          !__hasOwnProp.call(entry, key) &&
          __defProp(entry, key, {
            get: () => from[key],
            enumerable:
              !(desc = __getOwnPropDesc(from, key)) || desc.enumerable,
          }),
      );
    __moduleCache.set(from, entry);
    return entry;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, {
        get: all[name],
        enumerable: true,
        configurable: true,
        set: (newValue) => (all[name] = () => newValue),
      });
  };

  // assets/scripts/pickup-availability.ts
  var exports_pickup_availability = {};
  __export(exports_pickup_availability, {
    PickupAvailability: () => PickupAvailability,
  });

  // utils/getFocusableElements.ts
  var getFocusableElements = (container) => {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
      ),
    );
  };

  // utils/trapFocus.ts
  var trapFocusHandlers = {};
  var trapFocus = (container, elementToFocus = container) => {
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    removeTrapFocus();
    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;
      if (trapFocusHandlers.keydown) {
        document.addEventListener("keydown", trapFocusHandlers.keydown);
      }
    };
    trapFocusHandlers.focusout = () => {
      if (trapFocusHandlers.keydown) {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
      }
    };
    trapFocusHandlers.keydown = (event) => {
      if (event.code.toUpperCase() !== "TAB") return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };
    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);
    elementToFocus.focus();
    if (elementToFocus instanceof HTMLInputElement) {
      if (
        ["search", "text", "email", "url"].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    }
  };
  var removeTrapFocus = (elementToFocus = null) => {
    if (trapFocusHandlers.focusin) {
      document.removeEventListener("focusin", trapFocusHandlers.focusin);
    }
    if (trapFocusHandlers.focusout) {
      document.removeEventListener("focusout", trapFocusHandlers.focusout);
    }
    if (trapFocusHandlers.keydown) {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }
    if (elementToFocus) elementToFocus.focus();
  };

  // assets/scripts/pickup-availability.ts
  class PickupAvailability extends HTMLElement {
    errorHtml;
    boundRefreshList;
    constructor() {
      super();
      if (!this.hasAttribute("available")) return;
      const template = this.querySelector("template");
      const firstElement = template?.content.firstElementChild;
      if (!firstElement) return;
      this.errorHtml = firstElement.cloneNode(true);
      this.boundRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }
    fetchAvailability(variantId) {
      if (!variantId) return;
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl?.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
      fetch(variantSectionUrl)
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(".shopify-section");
          this.renderPreview(sectionInnerHTML);
        })
        .catch(() => {
          const button = this.querySelector("button");
          if (button)
            button.removeEventListener("click", this.boundRefreshList);
          this.renderError();
        });
    }
    onClickRefreshList() {
      this.fetchAvailability(this.dataset.variantId);
    }
    update(variant) {
      if (variant?.available) {
        this.fetchAvailability(String(variant.id));
      } else {
        this.removeAttribute("available");
        this.innerHTML = "";
      }
    }
    renderError() {
      this.innerHTML = "";
      this.appendChild(this.errorHtml);
      this.querySelector("button")?.addEventListener(
        "click",
        this.boundRefreshList,
      );
    }
    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector("pickup-availability-drawer");
      if (drawer) drawer.remove();
      if (!sectionInnerHTML?.querySelector("pickup-availability-preview")) {
        this.innerHTML = "";
        this.removeAttribute("available");
        return;
      }
      const previewElement = sectionInnerHTML.querySelector(
        "pickup-availability-preview",
      );
      if (previewElement) {
        this.innerHTML = previewElement.outerHTML;
      }
      this.setAttribute("available", "");
      const drawerElement = sectionInnerHTML.querySelector(
        "pickup-availability-drawer",
      );
      if (drawerElement) {
        document.body.appendChild(drawerElement);
      }
      const colorClassesToApply =
        this.dataset.productPageColorScheme?.split(" ") ?? [];
      colorClassesToApply.forEach((colorClass) => {
        document
          .querySelector("pickup-availability-drawer")
          ?.classList.add(colorClass);
      });
      const button = this.querySelector("button");
      if (button) {
        button.addEventListener("click", (evt) => {
          const drawerEl = document.querySelector("pickup-availability-drawer");
          const target = evt.target;
          drawerEl?.show(target);
        });
      }
    }
  }
  if (!customElements.get("pickup-availability")) {
    customElements.define("pickup-availability", PickupAvailability);
  }

  class PickupAvailabilityDrawer extends HTMLElement {
    onBodyClick;
    focusElement;
    constructor() {
      super();
      this.onBodyClick = this.handleBodyClick.bind(this);
      this.querySelector("button")?.addEventListener("click", () => {
        this.hide();
      });
      this.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") this.hide();
      });
    }
    handleBodyClick(evt) {
      const target = evt.target;
      if (
        target !== this &&
        !target.closest("pickup-availability-drawer") &&
        target.id !== "ShowPickupAvailabilityDrawer"
      ) {
        this.hide();
      }
    }
    hide() {
      this.removeAttribute("open");
      document.body.removeEventListener("click", this.onBodyClick);
      document.body.classList.remove("overflow-hidden");
      removeTrapFocus(this.focusElement ?? null);
    }
    show(focusElement) {
      this.focusElement = focusElement;
      this.setAttribute("open", "");
      document.body.addEventListener("click", this.onBodyClick);
      document.body.classList.add("overflow-hidden");
      trapFocus(this);
    }
  }
  if (!customElements.get("pickup-availability-drawer")) {
    customElements.define(
      "pickup-availability-drawer",
      PickupAvailabilityDrawer,
    );
  }
})();
